<iboxtools *ngIf="verDetalle" [Title]="" 
            isHistory='true' 
            [enableBack]="true" 
            [DateInit]="familiar?.desde" 
            [DateEnd]="familiar?.hasta"
            [IsEditing]="isEditing" 
            (BackChange)="OnBackChange()" 
            [PeriodList]="familiaresHistoryList" 
            (DeleteChange)="OnDeleteChange($event)" 
            (NewChange)="OnNewChange($event)"
            (EditChange)="OnEditChange($event)" 
            (PeriodChange)="OnPeriodChange($event)" 
            (CancelChange)="OnCancelChange($event)" 
            (SaveChange)="OnSaveChange($event)" 
            (CutChange)="OnCutChange()"
            [Permiso]="permisoEdicion"
            [CurrentPeriod]="familiar?.id">
</iboxtools>

<app-familiares-list *ngIf="!verDetalle && !buscando" [personalId]="personalId" 
                                                      [familiares]="familiares" 
                                                      [permisoEdicion]="permisoEdicion"
                                                      [fechaslist]="fechaslist"
                                                      (VisualizarDetalle)="OnVisualizarDetalle($event)">
</app-familiares-list>

<app-familiar-detalle #ChildFamiliarDetalle [familiar]="familiar" *ngIf="verDetalle" 
                              [enabledForm]="habilitarFormDetalle" 
                              [MensajeError]="MensajeError" 
                              [desdeAnterior]="desdeAnterior" 
                              [ingreso]="ingreso"
                              [anteriorRetroactividad]="anteriorRetroactividad" 
                              [grupoLiq]="gruposLiquidaciones" 
                              [familiaresInvalida]="familiaresInvalida"
                              [nacimientoposterior]="nacimientoposterior">
</app-familiar-detalle>

